import { useEffect, useState } from 'react';
import ComboBoxFormik from '../../../../../common/components/form/ComboBoxFormik';
import { createDebounce } from '../../../../../common/helpers/debounce.helper';
import { getPeriods, Period } from '../../../../../common/services/plans.api';

// Normaliza a chave do plano para facilitar a verificação
const normalizePlanKey = (label: string) => {
  const upper = label.toUpperCase();

  if (upper.includes("SV 0KM")) return "SV 0KM";
  if (upper.includes("SV SEMI")) return "SV Semi";
  if (upper.includes("SV FINISH")) return "SV Finish";
  if (upper.includes("SV")) return "SV";

  return label;
};

const isPlanAllowedByOdometer = (label: string, odometer: number) => {
  // sem odômetro válido: não filtra por km
  if (!Number.isFinite(odometer)) return true;

  const planKey = normalizePlanKey(label);

  if (!planKey.toUpperCase().includes("SV")) return true;
  if (planKey === "SV 0KM") return odometer >= 0 && odometer <= 9999;
  if (planKey === "SV") return odometer >= 10000 && odometer <= 59999;
  if (planKey === "SV Semi") return odometer >= 60000;
  if (planKey === "SV Finish") return true; // regra por data

  return true;
};

const getPeriodDebounced = createDebounce(getPeriods, 100);

interface AvailablePeriodsProps {
  onChange: (selectedPeriod) => void;
  action?: string;
  odometerLocavibe?: number | string;
}

export function AvailablePeriods({ onChange, action, odometerLocavibe }: AvailablePeriodsProps) {

  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);


  const loadOptions = async () => {
    const result = await getPeriodDebounced() as { ok: boolean, data: Period[] };
    let availablePlans = result.data.filter((item) => !item.label.toLowerCase().includes('moto'));

    if (action === "changePlan") {
      //adicionar plano com "moto" a availavlePlans
      const plansMotoclub = result.data.filter((item) => item.label.toLowerCase().includes('+7'));
      availablePlans = [...availablePlans, ...plansMotoclub];
    }
    availablePlans = availablePlans.filter((item) =>
      isPlanAllowedByOdometer(item.label, Number(odometerLocavibe))
    );
    if (result.ok) {
      setOptions([
        { label: 'Selecione', value: '' },
        ...availablePlans.map((item) => ({ label: item.label, value: item.label }))
      ]);
    } else {
      setOptions([{ label: 'Selecione', value: '' }]);
    }
  };


  useEffect(() => {
    loadOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value: unknown) => {
    onChange(value);
  };


  return (
    <ComboBoxFormik
      name="plan"
      label="Plano:"
      options={options}
      required
      onChange={handleChange}
    />
  );
}
